<template>
  <div class="ApplyForLegal">
    <h3>法人注册</h3>
    <p> 请输入法人相关信息</p>
    <van-form @submit="submit" class="second-phone-form">
      <div class="topic">
        <van-popup v-model="entType.show" position="bottom" :style="{ height: '30%' }">
          <van-picker
            :columns="entType.columns"
            show-toolbar
            title="请选择法人类型"
            :default-index="2"
            @confirm="onChange1"
            @cancel="onCancel1"
          />
        </van-popup>
        <van-field
          v-model="formData.entType"
          placeholder="请选择法人类型"
          @click="entType.show=true"
          clearable
          readonly
          class="userType from-field-phone"
        >
          <!-- <template slot="right-icon">
            <van-icon name="arrow-up" 
              style="width: 0.4rem;height: 0.4rem" 
              @click="entType.show=true"
            />
          </template> -->
        </van-field>  
        <van-field
          v-model="formData.entTname"
          placeholder="请填写企业名称"
          class="userType from-field-phone"
          :rules="[{ required: true, message: '必填' }]"
          clearable
        />
        <van-field
          v-model="formData.unitCode"
          type="text"
          placeholder="请输入统一社会信用代码"
          class="userType from-field-phone"
          :rules="[{ required: true, message: '必填' }]"
          clearable
        />
        <van-field
          :type="passwordType"
          v-model="formData.Password"
          placeholder="请输入密码(数字、字母大小写，不少于8位)"
          class="userType from-field-phone"
          :rules="[{ required: true, message: '请按规则填写密码',pattern:pwdReg }]"
          >
          <template slot="right-icon">
            <img style="width: 0.5rem;height: 0.5rem"
              :src="imgUrl"
              alt=""
              @click="switchPasswordType(0)">
          </template>
        </van-field>  
        <van-field
          v-model="formData.contactName"
          placeholder="请输入经办人姓名"
          class="userType from-field-phone"
          :rules="[{ required: true, message: '请输入经办人姓名' }]"
          clearable
        />
        <van-field
          v-model="formData.contactCode"
          placeholder="请输入经办人身份证号"
          class="userType from-field-phone"
          :rules="[{ required: true, message: '请输入正确身份证格式',pattern:idCardReg}]"
          clearable
        />
        <van-field
          v-model="formData.contactMobile"
          type="tel"
          name="phoneReg"
          placeholder="请输入经办人手机号码"
          class="userType from-field-phone"
          :rules="[{ required: true, message: '请输入正确手机格式',pattern:phoneReg }]"
          clearable
        />
        <van-field
          v-model="formData.verifycode"
          type="tel"
          center
          clearable
          maxlength="6"
          placeholder="请输入短信验证码"
          class="userType from-field-phone"
          :rules="[{ required: true, message: ' ' }]"
        >
          <template #button>
            <van-button
              size="small"
              type="info"
              @click="sendCode"
              v-if="codeShow"
              :text="getCodeText"
            ></van-button>
            <van-button size="small" type="info" @click="toastWait" v-else>{{count}} s</van-button>
          </template>
        </van-field>
        <div class="submit-item checkBox">
          <div>
            <van-checkbox v-model="check" shape="round" icon-size="15px" style="margin-top:-1px;"/>
          </div>
          <span style="color:#666666 ; margin-left: 6px">
            我已阅读并同意《
            <span class="checkbox-text" @click="protocol(1)">法人实名注册协议</span>》
          </span>
        </div>
        <!--提交按钮-->
        <div class="from-button">
          <van-button
            round
            block
            type="info"
            native-type="submit"
            :disabled="!formData.entType1 || !formData.entTname || !formData.unitCode || !formData.Password || !formData.contactName || !formData.contactCode || !formData.contactMobile || !formData.verifycode ||!check"
          >
            注册
          </van-button>
      </div>
      </div>
    </van-form>
    <van-popup v-model="txtShow" round :style="{ height: '85%',width:'82%' }">
      <protocolTxt :protocolContent="protocolContent" @iKnowBtnClick="iKnowBtnClick"></protocolTxt>
    </van-popup>
  </div>
</template>

<script>
import Vue from "vue";
import passwordDisplay from '@/assets/icons/pwdhide.png'
import textDisplay from '@/assets/icons/pwdshow.png'
import protocolTxt from "./protocolTxt.vue";
import { Dialog, Icon } from "vant";
import { request } from "../../utils/request";
import { LegalRep, LegalCode} from "../../api/user";
import { NumberKeyboard } from "vant";
import { NoticeBar, Button } from "vant";
import { mapGetters } from "vuex";
Vue.use(NoticeBar);
Vue.use(Button);
Vue.use(NumberKeyboard);
Vue.use(Icon);
export default {
  data() {
    return {
      protocolContent: "",
      txtShow: false,
      pwdReg: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[\s\S]{8,30}$/,
      check: false,
      passwordType: "password",
      repasswordType: "password",
      imgUrl: passwordDisplay,
      reimgUrl: passwordDisplay,
      count: 60,
      getCodeText: "获取验证码",
      codeShow: true,
      phoneReg: /^(((13[0-9]{1})|(15[0-9]{1})|(16[0-9]{1})|(17[3-8]{1})|(18[0-9]{1})|(19[0-9]{1})|(14[5-7]{1}))+\d{8})$/,
      idCardReg: /^(^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$)|(^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])((\d{4})|\d{3}[Xx])$)$/,
      showNum: false,
      formData: {
        entType: "",
        entType1: "",
        entTname: "",
        unitCode: "",
        Password: "",
        contactName: "",
        contactCode: "",
        contactMobile: "",
        verifycode: "",
        // userPhone:""
      },
      entType: {
        show: false,
        columns: [
          {
            text: "事业单位",
            id: 2
          },
          {
            text: "社团、民非、基金会",
            id: 3
          },
          {
            text: "企业、农专社、个体工商户",
            id: 1
          },
          {
            text: "政府机关",
            id: 4
          },

          {
            text: "居委会、村委会",
            id: 6
          },
          {
            text: "律师事务所",
            id: 7
          },
          {
            text: "军队",
            id: 8
          },
          {
            text: "其他组织",
            id: 99
          }
        ]
      },      
    };
  },
  components: {
    protocolTxt
  },
  computed: {
    ...mapGetters({ 
      idCard: 'idcard', 
      userName: 'userName', 
      // entType:'entType',
      // entTname:'entTname',
      // unitCode:'unitCode',
      }),
  },
  methods: {
    onChange1(value) {
      this.formData.entType1 = value.id;
      this.formData.entType = value.text;
      this.entType.show = false;
    },
    onCancel1() {
      this.entType.show = false;
    },
    switchPasswordType(flag){
      if(!flag){
        this.passwordType = this.passwordType === 'password' ? 'text' : 'password';
        this.imgUrl = this.passwordType === 'password' ? passwordDisplay : textDisplay;
      }else{
        this.repasswordType = this.repasswordType === 'password' ? 'text' : 'password';
        this.reimgUrl = this.repasswordType === 'password' ? passwordDisplay : textDisplay;
      }
    },
    protocol(num) {
      // 查看协议
      this.protocolContent = num;
      this.txtShow = true;
    },
    iKnowBtnClick() {
      this.txtShow = false;
    },
    toastWait() {
      this.$toast("请" + this.count + "秒后点击获取！");
    },
    sendCode() {
      var self = this;
      const TIME_COUNT = 60;
      // 调用发短信接口
      self.getCodeText = "发送中...";
      console.log(self.formData.contactMobile);
      LegalCode({
        mobiles: self.formData.contactMobile
      })
        .then(res => {
          console.log("发送成功");
          let { respCode, respMsg, sgasession } = res;
          if (respCode !== "00000000") {
            this.getCodeText = "获取验证码";
            this.$toast(respMsg);
          } else {
            this.$toast("短信发送成功");
            // 成功
            if (!this.timer) {
              this.count = TIME_COUNT;
              this.codeShow = false;
              this.timer = setInterval(() => {
                if (this.count > 0 && this.count <= TIME_COUNT) {
                  this.count--;
                } else {
                  this.codeShow = true;
                  clearInterval(this.timer);
                  this.timer = null;
                }
              }, 1000);
              this.getCodeText = "获取验证码";
            }
          }
        })
        .then(err => {
          // console.log("err", err);
        });
    },

    submit() {
      if (this.formData.entType1 === "") {
        this.$toast({
          message: "请选择法人类型"
        });
        return;
      }
      if (this.formData.entTname === "") {
        this.$toast({
          message: "请填写企业名称"
        });
        return;
      }
      if (this.formData.unitCode === "") {
        this.$toast({
          message: "请输入统一社会信用代码"
        });
        return;
      }
      if (this.formData.verifycode === "") {
        this.$toast({
          message: "请输入验证码"
        });
        return;
      }
      if (this.formData.Password === "") {
        this.$toast({
          message: "请输入密码"
        });
        return;
      }
      if (this.formData.contactName === "") {
        this.$toast({
          message: "请输入经办人姓名"
        });
        return;
      }
      if (this.formData.contactCode === "") {
        this.$toast({
          message: "请输入经办人身份证号"
        });
        return;
      }
      if (this.formData.contactMobile === "") {
        this.$toast({
          message: "请输入经办人手机号"
        });
        return;
      }
      if (!this.pwdReg.test(this.formData.Password)) {
        this.$toast({
          message: "请输入正确格式的密码格式"
        });
      }
      if (!this.phoneReg.test(this.formData.contactMobile)) {
        this.$toast({
          message: "请输入正确格式的手机号码"
        });
      }
      if (
        !this.idCardReg.test(this.formData.contactCode)
      ) {
        return this.$toast("请输入正确的身份证号");
      }
      if (this.formData.verifycode.length != 6) {
        return this.$toast("请输入6位短信验证码");
      }
      if (!this.check) {
        return this.$toast("请同意遵守相关协议和隐私政策");
      }
      LegalRep({
        entType: this.formData.entType1,
        entTname: this.formData.entTname,
        unitCode: this.formData.unitCode,
        legalName: this.userName,
        userCardnum: this.idCard,
        encrypId: this.formData.Password,
        agentName: this.formData.contactName,
        agentCard: this.formData.contactCode,
        agentPhone: this.formData.contactMobile,
        code: this.formData.verifycode,
        userIdtype:"0"//证件类型：身份证
      })
        .then(res => {
          console.log("这里是",res);
          let { respCode, respMsg, sgasession } = res;
          console.log("交易结果是",respCode)
          if (respCode === "00000000") {
            console.log("注册车iii")
            //注册成功
            this.$toast(respMsg);
            setTimeout(() => {
              this.JSBridge.closeNewWindow();
            }, 1500);
          } else {
              console.log("失败",respCode)
              console.log(respMsg)
              this.$toast(respMsg);
              // }
          }
        })
        .catch(err => {
          this.$toast({
            message: err
          });
        });
    },
  }
};
</script>

<style lang="less" scoped>
@blue: #108ee9;
.ApplyForLegal {
  box-sizing: border-box;
  padding: 20px 20px 0px 20px;
  height: 100vh;
  background: #fff;
  h3 {
  font-size: 0.8rem;
  color: #333333;
  margin-bottom: 5px;
  margin-top: 30px;    
  font-weight: 550;
  }
  p {
  font-size: 0.4rem;
  color: #999999;
  letter-spacing: 1.5px;
  margin-top: 15px;
  }
  .second-phone-form {
    margin-top: 20px;
  }
  .userType {
  font-size: 0.4rem;
  padding-left: 0;
  }
  .van-cell:not(:last-child)::after {
    border: none;
  }
  .van-cell {
    border-bottom: 0.02667rem solid #ebedf0;
  }
  .from-field-phone {
  font-size: 0.4rem;
  padding: 15px 0px;
  line-height: 25px;
  box-sizing: border-box;
  }
  .from-button {
    width: 100%;
    border-radius: 5px;
    // margin-top: 300px;
    button {
      border-radius: 3px;
      margin-top: 20px;
      height: 50px;
    }
  }
  /deep/ .van-button--disabled {
    background-color: #ebebeb;
    border-color: #ebebeb;
    opacity: 1;
  }
  .topic {
    background: #fff;
    padding-bottom: 32px;
    // .submit {
    //   margin-top: 1rem;
    //   font-family: AlibabaPuHuiTiM;
    //   font-weight: 400;
    //   color: rgba(255, 255, 255, 1);
    //   font-size: 16px;
    //   width: 100%;
    //   height: 40px;
    //   background: rgba(16, 142, 233, 1);
    //   border-radius: 6px;
    // }
  }
}

.submit-item {
  display: flex;
  align-items: center;
  span {
    font-size: 10px;
  }

}
.checkBox {
  margin-top: 18px;
  margin-bottom: 5px;
  // padding: 0 20px;
  /deep/ .van-checkbox__icon .van-icon {
    border-color: @blue;
    // border-radius: 3px;
  }
  .checkbox-text {
    color: @blue;
  }
}
</style>